import { useGetPlansQuery } from '../../slice/createSettingApiSlice'
import { IPlan, PlanTypes } from '../../../../shared/utils/interfaces/planInterface';
import { Warning } from '../../../../shared/components/Warning/Warning';
import PlanCard from './PlanCard';
import PlansSkeleton from './PlansSkeleton';
import { errorMessage } from '../../../../shared/utils/constantData'
import { openCheckout } from '../../../../shared/components/payment/paddle';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsSuccessUpgradePlan, setPlansModalOpen } from '../../slice/settingsSlice';
import { useEffect, useState } from 'react';
import { useGetUserCurrentPlan } from '../../../../shared/utils/customHooks/useGetUserCurrentPlan';

export default function PlansList({ publicView }: { publicView?: boolean }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isSuccess, isError, data } = useGetPlansQuery();
    const [selectedPlanId, setSelectedPlanId] = useState<PlanTypes>()
    const isSuccessSubscribe = useSelector(selectIsSuccessUpgradePlan)
    const { getUserPlan } = useGetUserCurrentPlan()
    
    useEffect(() => {
        if (isSuccessSubscribe) {
            getUserPlan()
        }
        // eslint-disable-next-line
    }, [isSuccessSubscribe, dispatch])

    const handleSubscribe = (priceId: string, planId: PlanTypes) => {
        if (planId === PlanTypes.free) {
            dispatch(setPlansModalOpen(false))
            navigate('/settings/profile', { state: { scrollDown: true } })
        }
        else {
            setSelectedPlanId(planId)
            openCheckout(priceId)
        };
    }

    return (
        <>
            {isError ?
                <Warning title={errorMessage} message='Please refresh to reload our plans' btnText='Refresh' />
                : isSuccess ?
                    <div className={`grid gap-6 lg:grid-cols-${data?.plans?.length}`}>
                        {Array.isArray(data?.plans) && data?.plans?.map((plan: IPlan) => {
                            return (
                                <PlanCard publicView={publicView} plan={plan} handleSubscribe={() => handleSubscribe(plan?.paddlePriceId, plan?.id)} key={plan?.id} selectedPlanId={selectedPlanId} />
                            )
                        })}
                    </div>
                    : <PlansSkeleton />
            }
        </>
    )
}
